module.exports = __webpack_public_path__ + "static/media/picture-min.7d1c0542.jpg";